
import * as types from '../types';
import {
  SET_VEHICLES_DATA
} from '../types';

//@ts-ignore
export function setVehicleLoadClass (data) {
  return {
    type: types.SET_VEHICLE_LOADCLASS,
    data
  };
}
//@ts-ignore
export function setVehiclesData (data) {
  return {
    type: SET_VEHICLES_DATA,
    data
  };
}
